import { imageAsset, link, videoAsset } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  subtitle,
  showLogo,
  "sectionBackground": 'black',
  ${link.fragment('primaryCta')},
  ${link.fragment('secondaryCta')},
  mediaType,
  overlayOpacity,
  ${imageAsset.fragment('image')},
  ${videoAsset.fragment('videoLoopDesktop')},
  ${videoAsset.fragment('videoLoopMobile')},
  ${imageAsset.fragment('transparentOverlayDesktop')},
  ${imageAsset.fragment('transparentOverlayMobile')}
`

export const fragment = (name = 'homepageHero') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
